import {
    ArrowType,
    OrderType,
    KINTEKI,
    ENTEKI,
    MAKIWARA,
    FULL,
    SEMI,
} from '@app/react/const/type';
import type { DesignSet } from '@app/react/const/type';
import { isDesignSet } from '@app/react/common/isDesignSet';

interface YourDesignState {
    param: {
        kintekiFull: Array<DesignSet>;
        kintekiSemi: Array<DesignSet>;
        entekiFull: Array<DesignSet>;
        entekiSemi: Array<DesignSet>;
        makiwaraFull: Array<DesignSet>;
    };
}

export const removeItem = (
    state: YourDesignState,
    id: number,
    baseId: number,
    arrowType: ArrowType,
    orderType: OrderType,
): YourDesignState => {
    if (arrowType === KINTEKI && orderType === FULL) {
        const items = state.param.kintekiFull;
        return {
            ...state,
            param: {
                ...state.param,
                kintekiFull: items.filter((item) => !isDesignSet(item, { id, baseId })),
            },
        };
    } if (arrowType === KINTEKI && orderType === SEMI) {
        const items = state.param.kintekiSemi;
        return {
            ...state,
            param: {
                ...state.param,
                kintekiSemi: items.filter((item) => !isDesignSet(item, { id, baseId })),
            },
        };
    } if (arrowType === ENTEKI && orderType === FULL) {
        const items = state.param.entekiFull;
        return {
            ...state,
            param: {
                ...state.param,
                entekiFull: items.filter((item) => !isDesignSet(item, { id, baseId })),
            },
        };
    } if (arrowType === ENTEKI && orderType === SEMI) {
        const items = state.param.entekiSemi;
        return {
            ...state,
            param: {
                ...state.param,
                entekiSemi: items.filter((item) => !isDesignSet(item, { id, baseId })),
            },
        };
    } if (arrowType === MAKIWARA && orderType === FULL) {
        const items = state.param.makiwaraFull;
        return {
            ...state,
            param: {
                ...state.param,
                makiwaraFull: items.filter((item) => !isDesignSet(item, { id, baseId })),
            },
        };
    }

    return state;
};
